module.exports = __webpack_public_path__ + "static/media/f_hairstyle_curly_medium_back.63ddb09f.png";